import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';

import { cardF } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FvcFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FvcFormComponent),
    },
  ],
  selector: 'app-fvc-form',
  styleUrls: ['./fvc-form.component.scss'],
  templateUrl: './fvc-form.component.html',
})
export class FvcFormComponent extends BaseCtrlValueAccessorFormComponent<cardF.FVC> {
  constructor() {
    super();
  }
}
